/**
 * PURPOSE: Consumir el catálogo administrativo V2 de sedes desde Winscore.
 * RESPONSIBILITIES: Listar sedes activas por evento/compañía y crear sedes con referencias obligatorias.
 * COLLABORATORS: VenueSelect.jsx, ModalProgramacion.jsx y backend/src/hayllis-v2/venues.
 * ROUTE: winscore/src/services/hayllisV2VenueService.js
 */
import axios from "axios";
import API_BASE_URL from "../config/config.js";

const BASE_PATH = `${API_BASE_URL}/api/hayllis/v2/venues`;
const unwrap = (response) => response.data?.data || response.data || {};

export const listHayllisV2Venues = async ({ idevent, idcompany }) => {
  const response = await axios.get(BASE_PATH, {
    params: {
      idevent: Number(idevent),
      idcompany: Number(idcompany),
      includeInactive: false,
    },
  });
  const payload = unwrap(response);
  return Array.isArray(payload.venues) ? payload.venues : [];
};

// Desde Programación se envía idevent: el backend autoriza por la regla de evento y deriva la
// compañía del evento (FTR-0012, Decisión 2); idcompany debe coincidir con la del evento.
export const createHayllisV2Venue = async ({
  name,
  address,
  linkMap,
  iddepartamento,
  idcompany,
  idevent,
}) => {
  const response = await axios.post(BASE_PATH, {
    name: String(name || "").trim(),
    address: String(address || "").trim() || null,
    linkMap: String(linkMap || "").trim() || null,
    iddepartamento: Number(iddepartamento),
    idcompany: Number(idcompany),
    ...(Number(idevent) > 0 ? { idevent: Number(idevent) } : {}),
    state: 1,
  });
  return unwrap(response).venue;
};
